/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES Media List API
 * PR TIMESメディアリスト用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * サブカテゴリ
 * @export
 * @interface MediaSubcategory
 */
export interface MediaSubcategory {
    /**
     * サブカテゴリID
     * @type {number}
     * @memberof MediaSubcategory
     */
    subcategoryId: number;
    /**
     * サブカテゴリ名
     * @type {string}
     * @memberof MediaSubcategory
     */
    subcategoryName: string;
}

export function MediaSubcategoryFromJSON(json: any): MediaSubcategory {
    return MediaSubcategoryFromJSONTyped(json, false);
}

export function MediaSubcategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaSubcategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subcategoryId': json['subcategory_id'],
        'subcategoryName': json['subcategory_name'],
    };
}

export function MediaSubcategoryToJSON(value?: MediaSubcategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subcategory_id': value.subcategoryId,
        'subcategory_name': value.subcategoryName,
    };
}

